import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import { ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_ROUTE_NAME, AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS } from '../../constants';
import {
  ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesNoneNegativeCarryoverHistoryEditModule extends AppModule {
  protected submodules: AppModule[] = [];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT_ROUTE_NAME,
      path: 'history/:itemId',
      permission: AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS.EDIT,
      component: () => import('./pages/AffiliateNoneNegativeCarryoverHistoryEditPage/AffiliateNoneNegativeCarryoverHistoryEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_NONE_NEGATIVE_CARRYOVER_HISTORY_EDIT, getTranslationKeys);
  }
}
